import React, { Fragment, useReducer } from "react";
import { useState } from "react";
import { Table } from "reactstrap";
import { getData, postData, localizeTZ } from "./../Utils";
import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import * as moment from "moment";
import Comments from "./Comments";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { useGlobalState } from "../global";

const initalsession = {
  started_at: "",
  ended_at: "",
  price_total: 0,
  duration_seconds: 0,
  trailer_reg_number: "",
  first_unlock_time: "",
  payment_id: "",
  payement_status: "",
};
const initalUser = {
  created_at: "",
  name: "",
  email: "",
  phone: "",
};
const initaquestions = []; // [{"id": 19, "left_by": "ff1213344", "trailer_id": 8, "session_id": 18, "question_title": "Is the trailer clean", "answer_title": "Yes", "answer_type": "Positive", "comment": "", "resolved": false, "created_at": "2020-05-16 19:50:58.874801", "resolved_at": null, "resolved_by": null, "left_at": "end", "photos": []}, {"id": 20, "left_by": "ff1213344", "trailer_id": 8, "session_id": 18, "question_title": "Is there any damage", "answer_title": "Yes", "answer_type": "Negative", "comment": "Left taillight was broken", "resolved": false, "created_at": "2020-05-16 19:50:58.875090", "resolved_at": null, "resolved_by": null, "left_at": "end", "photos": ["data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQAB", "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQAB"]}, {"id": 21, "left_by": "ff1213344", "trailer_id": 8, "session_id": 18, "question_title": "Is the trailer clean", "answer_title": "Yes", "answer_type": "Positive", "comment": "", "resolved": false, "created_at": "2020-05-16 20:27:31.921639", "resolved_at": null, "resolved_by": null, "left_at": "end", "photos": []}, {"id": 22, "left_by": "ff1213344", "trailer_id": 8, "session_id": 18, "question_title": "Is there any damage", "answer_title": "Yes", "answer_type": "Negative", "comment": "Left taillight was broken", "resolved": false, "created_at": "2020-05-16 20:27:31.921960", "resolved_at": null, "resolved_by": null, "left_at": "end", "photos": ["data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQAB", "data:image/jpeg;base64,/9j/XDFSSS\\u00df"]}, {"id": 23, "left_by": "ff1213344", "trailer_id": 8, "session_id": 18, "question_title": "Is the trailer clean", "answer_title": "Yes", "answer_type": "Positive", "comment": "", "resolved": false, "created_at": "2020-05-16 20:29:39.777891", "resolved_at": null, "resolved_by": null, "left_at": "end", "photos": []}, {"id": 24, "left_by": "ff1213344", "trailer_id": 8, "session_id": 18, "question_title": "Is there any damage", "answer_title": "Yes", "answer_type": "Negative", "comment": "Left taillight was broken", "resolved": false, "created_at": "2020-05-16 20:29:39.778171", "resolved_at": null, "resolved_by": null, "left_at": "end", "photos": ["data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQAB", "data:image/jpeg;base64,/9j/XDFSSS\\u00df"]}]

export default function Session() {
  const params = useParams();
  const id = params.id;
  const [details, updateDetails] = useState(initalsession);
  const [users, updateUsers] = useState(initalUser);
  const [questions, updateQuestions] = useState(initaquestions);
  const [signature, updateSignature] = useState();
  const detailsRows = Object.entries(details).map((row) => (
    <tr key={row[0]}>
      <td>{row[0]}</td>
      <td>{row[1]}</td>
    </tr>
  ));
  const userRows = Object.entries(users).map((row) => (
    <tr key={row[0]}>
      <td>{row[0]}</td>
      <td>{row[1]}</td>
    </tr>
  ));
  useEffect(() => {
    getData(`sessions/${id}/details`).then((r) => {
      const d = r.details;
      d.started_at = localizeTZ(d.started_at);
      d.ended_at = localizeTZ(d.ended_at);
      d.first_unlock_time = localizeTZ(d.first_unlock_time);
      updateDetails(d);
      updateUsers(r.user);
      updateQuestions(r.questions);
      updateSignature(r.signature);
    });
  }, []);

  return (
    <React.Fragment>
      <h3>Session Details</h3>
      <Table striped hover size="sm">
        <tbody>{detailsRows}</tbody>
      </Table>
      <h3>User Details</h3>
      <Table striped hover size="sm">
        <tbody>{userRows}</tbody>
      </Table>
      <Signature signature={signature} />
      <h3>Payment actions</h3>
      <PaymentFunctions id={id} details={details} />
      <h3>Session Comments</h3>
      <Comments comments={questions}></Comments>
      {users.id && !users.id.startsWith("man") && <Link to={`/invoice/${id}`}>Invoice</Link>}
    </React.Fragment>
  );
}

function PaymentFunctions(props) {
  const { id, details } = props;
  console.log(id);
  console.log(details);
  const [state, dispatch] = useGlobalState();
  const [refundReason, updateRefundReason] = useState("");
  const [refundAmount, updateRefundAmount] = useState("");
  const [solveReason, updateSolveReason] = useState("");
  const refund = () => {
    let body = { reason: refundReason };
    if (refundAmount) {
      body.amount = refundAmount;
    }
    postData(`sessions/${id}/refund`, body)
      .then((r) => {
        dispatch({ message: "Refund successful" });
      })
      .catch((error) => {
        dispatch({ error: `Error: ${error}` });
      });
  };
  const solve = () => {
    postData(`sessions/${id}/solve`, { reason: solveReason })
      .then((r) => {
        dispatch({ message: "Solve successful" });
      })
      .catch((error) => {
        dispatch({ error: `Error: ${error}` });
      });
  };
  return (
    <div>
      {details.payement_status === "SUCCEEDED" && (
        <Form inline>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label className="mr-sm-2">Refund </Label>
            <Input className="mr-sm-2" type="text" value={refundReason} onChange={(e) => updateRefundReason(e.target.value)} placeholder="refund reason" />
            <Input className="mr-sm-2" type="number" value={refundAmount} onChange={(e) => updateRefundAmount(e.target.value)} placeholder="amount" />
            <Button className="mr-sm-2" onClick={refund}>
              Refund
            </Button>
          </FormGroup>
        </Form>
      )}
      {!["SUCCEEDED", "REFUNDED", "SOLVED"].includes(details.payement_status) && (
        <Form inline style={{ "margin-top": "10px" }}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label className="mr-sm-2">Solve </Label>
            <Input className="mr-sm-2" type="text" value={solveReason} onChange={(e) => updateSolveReason(e.target.value)} placeholder="solve reason" />
            <Button className="mr-sm-2" onClick={solve}>
              Solve
            </Button>
          </FormGroup>
        </Form>
      )}
    </div>
  );
}

function Signature(props) {
  const { signature } = props;
  if (signature) {
    return (
      <>
        <h3>Signature</h3>
        <div style={{ width: "100%", margin: "2px" }}>
          <img alt="preview" size="50%" className="treiler-image-preview" src={signature} />
        </div>
      </>
    );
  }
  return <></>;
}
